"use client";
import YouTube, { YouTubeProps } from "react-youtube";

import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/plugins/counter.css";
import parse from "html-react-parser";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { useTranslations } from "next-intl";

import { useEffect, useRef } from "react";

/* eslint-disable no-undef */
declare const process: any;

export const Portafolio = () => {
  //const t = useTranslations("home");
  const [open, setOpen] = useState(false);
  const [galeria, setGaleria] = useState<any[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  /*
  function getYouTubeId(url: string) {
    const match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    );
    return match ? match[1] : null;
  }
*/

  function getYouTubeId(url: string) {
    const regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    // Esta línea específica ayuda con los shorts
    const shortExp = /shorts\/([a-zA-Z0-9_-]{11})/;

    const match = url.match(regExp);
    const shortMatch = url.match(shortExp);

    if (shortMatch) return shortMatch[1];
    return match && match[7].length === 11 ? match[7] : null;
  }

  const [currentSlide, setCurrentSlide] = useState(0);

  const playerRefs = useRef([]);
  const lastStateRef = useRef({});
  const isReadyRef = useRef({});
  const wasPlayingRef = useRef({});

  // Refs
  const thumbRefs = useRef([]);
  const scrollContainerRef = useRef(null);

  /*
  useEffect(() => {
    playerRefs.current.forEach((player, idx) => {
      const isValid =
        player &&
        typeof player.pauseVideo === "function" &&
        typeof player.playVideo === "function";

      if (!isValid) return;

      try {
        if (idx !== currentSlide) {
          // Guardamos si estaba reproduciendo antes de pausar
          const state = player.getPlayerState();
          wasPlayingRef.current[idx] = state === 1;
          player.pauseVideo();
        } else {
          // Al volver, reproducimos solo si estaba en play
          if (wasPlayingRef.current[idx]) {
            setTimeout(() => {
              try {
                player.playVideo();
              } catch (err) {
                console.warn(`Error al reproducir video en slide ${idx}`, err);
              }
            }, 300); // ⏱ espera defensiva para que el iframe esté listo
          }
        }
      } catch (err) {
        console.warn(`Error en slide ${idx}`, err);
      }
    });
  }, [currentSlide]);
*/
  /*
  const opts = {
    width: "100%",
    height: "100%",
    playerVars: {
      autoplay: 0, // 👈 evita reproducción automática
      modestbranding: 1,
      rel: 0,
      controls: 1,
      preload: true, // This line hides the "More Videos" overlay
      fs: 1, // ✅ habilita el botón de fullscreen
    },
  };
*/

  // 1. Solución al error de tipos en opts
  const opts: YouTubeProps["opts"] = {
    height: "100%",
    width: "100%",
    playerVars: {
      // Usar valores específicos que la API de YouTube acepta
      autoplay: 0 as 0 | 1,
      modestbranding: 1,
      rel: 0,
      controls: 1,
      fs: 1,
    },
  };

  const projectKeys = [
    "tiendabrando",
    "powerbit",
    "elcazadorgym",
    "juegounirverso",
    "bicicletaselectricas",
    "marcosbrandolinportafolio",
  ] as const;

  const portafolio = {
    1: {
      titulo: "Umbra",
      url: "https://youtu.be/_T65x-3Bv38",
      descripcion:
        "We developed the audiovisual production for Umbra, a cinematic piece created for a film festival that stands out for its technical complexity. The project included advanced visual effects to accurately recreate the 2008 solar eclipse. The work achieved great success and was highly rated by renowned director Eliseo Subiela, validating the aesthetic and technical quality of our production.",
      imagenes: {
        carpeta: "umbra",
        portada: "umbra1.jpg",
        galeria: ["umbra.jpg", "umbra1.jpg"],
        videos: ["https://youtu.be/_T65x-3Bv38"],
      },
      fechaIgnaguracion: "08/08/2008",
      version: "1.0",
    },
    2: {
      titulo: "cts.animacion3d",
      url: "https://www.bicicletaselectricas.com.ar/",
      descripcion: "portfolio.projects.bicicletaselectricas.description",
      imagenes: {
        carpeta: "bicicletaselectricas",
        portada: "bicicletaselectricas2.jpg",
        galeria: ["bicicletaselectricas2.jpg"],
      },
      fechaIgnaguracion: "08/10/2025",
      version: "1.0",
    },
    3: {
      titulo: "Tienda Brando",
      url: "https://www.tiendabrando.com.ar/",
      descripcion:
        "We developed an e-commerce platform for this construction industry company. The site features a full product catalog, shopping cart, and an admin panel that allows for easy management of products. The design is fully optimized for mobile and desktop devices, built using a modern tech stack to ensure high speed, stability, and a seamless user experience. We implemented smart advertising campaigns across multiple digital platforms to reach users actively searching for construction products. Additionally, we applied SEO strategies to boost search engine visibility on Google.",
      imagenes: {
        carpeta: "tiendabrando",
        portada: "tiendabrando4.jpg",
        galeria: [
          "tiendabrando1.jpg",
          "tiendabrando2.jpg",
          "tiendabrando3.jpg",
          "tiendabrando4.jpg",
          "tiendabrando5.jpg",
          "tiendabrando6.jpg",
          "tiendabrando7.jpg",
          "tiendabrando8.jpg",
          "tiendabrando9.jpg",
          "tiendabrando10.jpg",
        ],
      },
      fechaIgnaguracion: "05/11/2025",
      version: "2.01",
    },
    4: {
      titulo: "Power Bit",
      url: "https://powerbit.com.ar/",
      descripcion:
        "We launched Powerbit, a digital solutions agency dedicated to web design, advertising, and strategic marketing. We offer services including audiovisual production, social media content creation, and high-impact advertising campaigns. We specialize in the development of e-commerce platforms, custom websites, system automation, 2D/3D animation, and AI-driven solutions. Do you have a project in mind? Contact us and let’s make it happen!",
      imagenes: {
        carpeta: "powerbit",
        portada: "powerbit1.jpg",
        galeria: [
          "powerbit1.jpg",
          "powerbit2.jpg",
          "powerbit3.jpg",
          "powerbit4.jpg",
          "powerbit5.jpg",
        ],
        videos: ["https://www.youtube.com/shorts/39PgS02EHYw"],
      },
      fechaIgnaguracion: "15/12/2023",
      version: "2.3",
    },
    5: {
      titulo: "El Cazador GYM",
      url: "https://www.elcazadorgym.com.ar/fitnesscontrol/",
      demo: {
        descripcion: `<p classname="pb-1 negrita">Login Credentials:</p><div classname='leading-4'>DNI: 11222333 <br> Password: at4sk6</div>`,
      },
      descripcion:
        "We developed a fitness tracking web platform for gym members. Users can record body measurements and track their progress month-to-month from any browser, on both mobile and desktop devices. The system features an adaptive avatar, historical comparisons, and interactive charts that display progress clearly. It was built with modern tech and includes secure user registration. Additionally, we set up automated WhatsApp notifications to remind users to log their progress, helping them stay committed to their training habits.",
      imagenes: {
        carpeta: "elcazadorgym",
        portada: "elcazadorgym1.jpg",
        galeria: [
          "elcazadorgym1.jpg",
          "elcazadorgym2.jpg",
          "elcazadorgym3.jpg",
          "elcazadorgym4.jpg",
          "elcazadorgym5.jpg",
          "elcazadorgym6.jpg",
        ],
      },
      fechaIgnaguracion: "26/03/2026",
      version: "1.14",
    },
    6: {
      titulo: "Marcos Brandolin Portfolio",
      url: "https://marcosbrandolin.vercel.app/",
      descripcion:
        "We published this portfolio to showcase Marcos's professional progress. Here you will find his full resume, the projects he has developed over the past few years, and the technologies he works with daily. If you are looking for someone to solve your needs with modern solutions, you can contact him.",
      imagenes: {
        carpeta: "marcos-brandolin-portafolio",
        portada: "marcosbrandolin-portafolio.jpg",
        galeria: ["marcosbrandolin-portafolio.jpg"],
      },
      fechaIgnaguracion: "29/03/2026",
      version: "1.1",
    },
    7: {
      titulo: "The Dino Game",
      url: "https://juego-jurasico.vercel.app/",
      descripcion:
        "Inspired by the famous Chrome dinosaur game, we set out to reimagine that iconic experience with a fresh look. We kept the core mechanics of reflexes and simplicity while adding our own design and personality. This project captures nostalgia and transforms it into something new and visually engaging. It is a tribute that offers a fun and unique proposal. Do you want to play?",
      imagenes: {
        carpeta: "juego-jurasico",
        portada: "juego-jurasico1.jpg",
        galeria: ["juego-jurasico1.jpg", "powerbit1.jpg"],
      },
      fechaIgnaguracion: "17/12/2025",
      version: "1.2",
    },
    8: {
      titulo: "Electric Bikes",
      url: "https://www.bicicletaselectricas.com.ar/",
      descripcion:
        "We launched an online store specializing in urban mobility, featuring electric bikes, scooters, and accessories. The platform allows users to easily browse the catalog and make purchases from any device. We developed the site with modern technologies to ensure a smooth and fast user experience. To boost its reach, we ran targeted social media ad campaigns across several digital platforms. Purchases can be made via MercadoPago, with flexible payment options including installments and credit cards.",
      imagenes: {
        carpeta: "bicicletaselectricas",
        portada: "bicicletaselectricas2.jpg",
        galeria: [
          "bicicletaselectricas2.jpg",
          "bicicletaselectricas3.jpg",
          "bicicletaselectricas4.jpg",
          "bicicletaselectricas5.jpg",
          "bicicletaselectricas6.jpg",
          "bicicletaselectricas7.jpg",
          "bicicletaselectricas8.jpg",
        ],
      },
      fechaIgnaguracion: "08/10/2025",
      version: "1.0",
    },
    9: {
      titulo: "Pic Nic",
      url: "https://www.instagram.com/reel/DWB8mOMEfYT/",
      descripcion:
        "We handled the end-to-end production of reels and audiovisual content for Picnic, a food establishment in Parque Patricios. The project included filming and editing optimized for Instagram, TikTok, YouTube, and Facebook. The campaign achieved high viewership and excellent reception, meeting the client’s branding goals and strengthening their digital presence through creative content.",
      imagenes: {
        carpeta: "picnic",
        portada: "picnic.jpg",
        galeria: ["picnic.jpg"],
        videos: ["https://www.youtube.com/shorts/KSsm89AMlBc"],
      },
      fechaIgnaguracion: "18/03/2026",
      version: "1.0",
    },
  };
  /*
  const selectedGaleria = (key: string) => {
    const item = (portafolio as any)[key];
    const selectedGaleria = item.imagenes.galeria.map((imagen: string) => ({
      src: `/imagenes/portafolio/${item.imagenes.carpeta}/${imagen}`,
    }));
    setGaleria(selectedGaleria);
    setCurrentIndex(0);
    setOpen(true);
  };
*/

  const selectedGaleria = (key: string) => {
    const item = (portafolio as any)[key];

    // 1. Mapeamos las imágenes
    const imagenesMapped = item.imagenes.galeria.map((imagen: string) => ({
      src: `${process.env.REACT_APP_URL_FOLDER}/imagenes/portafolio/${item.imagenes.carpeta}/${imagen}`,
      type: "image" as const, // Forzamos el literal para TypeScript
    }));

    // 2. Mapeamos los videos (si existen)
    const videosMapped = (item.imagenes.videos || []).map(
      (videoUrl: string) => ({
        src: videoUrl,
        type: "video" as const,
      }),
    );

    // 3. Juntamos ambos arrays
    const combinados = [...imagenesMapped, ...videosMapped];

    setGaleria(combinados);
    setCurrentIndex(0);
    setOpen(true);
  };

  return (
    <section
      className="margen1 seccion-light  bg-[#EEF2FF] dark:bg-[#050817]"
      id="portfolio">
      <h1 className=" titulo1 text-center mb-[1rem]">Our Work</h1>

      <div className="portafolios">
        {Object.entries(portafolio)
          .reverse()
          // Filtramos: solo pasan los que NO tengan la key "2"
          .filter(([key]) => key !== "2")
          .map(([key, item]) => (
            <div
              key={key}
              className="text-center grid grid-cols-1 lg:grid-cols-12 gap-7 p-2 separador">
              <div className="order-2 lg:order-1 lg:col-span-6">
                <h2 className="lg:text-3xl text-xl font-bold">
                  {item.titulo}
                  <a
                    href={item.url}
                    target="_blank"
                    className="relative top-[-4px]  text-base   decoration-[#274dd8] hover:decoration-[#000] text-white-600">
                    <FontAwesomeIcon
                      icon={faArrowUpRightFromSquare}
                      size="lg"
                      className="ico-col3 ml-1 text-sm"
                    />
                  </a>
                </h2>
                <p className="text-sm mb-2 hidden">
                  {item.url}
                  <a
                    href={item.url}
                    target="_blank"
                    className="underline font-semibold text-base underline underline-offset-4 decoration-[#274dd8] hover:decoration-[#000] text-white-600">
                    <FontAwesomeIcon
                      icon={faArrowUpRightFromSquare}
                      size="lg"
                      className="ico-col3 ml-1 text-sm"
                    />
                  </a>
                </p>
                <div
                  className=" pt-1 pb-2"
                  dangerouslySetInnerHTML={{ __html: item.descripcion }}
                />

                {"demo" in item && (
                  <div className="text-sm pt-2">
                    {(item as any).demo.url && (
                      <a href={(item as any).demo.url} target="_blank">
                        {(item as any).demo.url}
                      </a>
                    )}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: (item as any).demo.descripcion,
                      }}
                    />
                  </div>
                )}
                <p className=" pt-2">
                  <span className="font-bold  block md:inline">
                    Last updated:
                  </span>{" "}
                  <span> {item.fechaIgnaguracion}</span>
                </p>
                <p className="">
                  <span className="font-bold block md:inline">Version:</span>{" "}
                  {item.version}
                </p>
              </div>
              <div className="lg:col-span-6 order-1 lg:order-2">
                <img
                  src={
                    process.env.REACT_APP_URL_FOLDER +
                    `/imagenes/portafolio/${item.imagenes.carpeta}/${item.imagenes.portada}`
                  }
                  alt={item.imagenes.galeria[0]}
                  className="object-contain w-full cursor-pointer"
                  onClick={() => {
                    selectedGaleria(key);
                  }}
                />
              </div>
            </div>
          ))}
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={galeria}
        index={currentIndex}
        // 1. Actualizamos el index local cada vez que el usuario desliza
        on={{ view: ({ index }) => setCurrentIndex(index) }}
        render={{
          // Eliminamos 'slides' de la desestructuración para evitar el error de tipos
          slide: ({ slide }) => {
            // Buscamos el índice comparando el objeto actual con nuestro estado 'galeria'
            const slideIndex = galeria.findIndex((s) => s.src === slide.src);

            if (slide.type === "image") {
              return <img src={slide.src} alt="" className="lightbox-image" />;
            }

            if (slide.type === "video") {
              // Usamos el slideIndex calculado para decidir si montamos el video
              return slideIndex === currentIndex ? (
                <div className="bg-black w-full h-full flex items-center justify-center">
                  <YouTube
                    videoId={getYouTubeId(slide.src) ?? undefined}
                    opts={opts}
                    className="w-full h-full"
                  />
                </div>
              ) : (
                <div className="bg-black w-full h-full" />
              );
            }
            return null;
          },
        }}
        carousel={{
          finite: true,
          padding: "0px",
          // preload: 1, // No precarga los costados, solo monta el actual
        }}
        plugins={[Counter]}
        counter={{ container: { style: { top: "unset", bottom: 0, left: 0 } } }}
      />
    </section>
  );
};
/*

         <div className="bg-black w-full h-full ">
              <YouTube
                videoId={
                  getYouTubeId("https://youtu.be/_T65x-3Bv38") ?? undefined
                }
                opts={opts} 
                className="w-full h-full "
              />
            </div>


      */

/*
            
            
             render={{
          slide: ({ slide }) =>
            slide.type === "image" ? (
              <img src={slide.src} alt="" className="lightbox-image" />
            ) : (
              <div className="bg-black w-full h-full ">
                <YouTube
                  videoId={
                    getYouTubeId("https://youtu.be/_T65x-3Bv38") ?? undefined
                  }
                  opts={opts}
                  className="w-full h-full "
                />
              </div>
            ),
        }}
            */
